


























































































































































import { SearchBuilder } from "@/builder";
import { debounceProcess } from "@/helpers/debounce";
import { useContactData } from "@/hooks";
import { Option } from "@/models/class/option.class";
import { RequestQueryParams } from "@/models/class/request-query-params.class";
import { ResponsePagination } from "@/models/constant/interface/common.interface";
import { DEFAULT_DATE_FORMAT } from "@/models/constants/date.constant";
import { Messages } from "@/models/enums/messages.enum";
import { ListContactDataDto } from "@/models/interface/contact-data";
import { RequestQueryParamsModel } from "@/models/interface/http.interface";
import { DataResponseBastWithdrawl } from "@/models/interface/salesOrder.interface";
import { salesOrderServices } from "@/services/salesorder.service";
import moment, { Moment } from "moment";
import Vue from "vue";

const SEARCH_FIELD = {
  DOCUMENT_NO: "internalContract.documentNo",
  CUSTOMER_ID: "internalContract.customer.secureId",
  WITHDRAWAL_NUMBER: "withdrawlNumber",
  UNIT_CODE: "unit.unitCode",
  WITHDRAWAL_DATE: "withdrawalDate",
} as const;

const FORM_FIELD = {
  CUSTOMER_NAME: "customerName",
  INTERNAL_CONTRACT_NUMBER: "internalContractNumber",
  WITHDRAWAL_NUMBER: "withdrawalNumber",
  UNIT_CODE: "unitCode",
  WITHDRAWAL_DATE: "withdrawalDate",
} as const;

interface LoadingComponent {
  loadingFind: boolean;
  loadingInternalContractNumber: boolean;
  download: boolean;
  print: boolean;
  loadingStatus: boolean;
  loadingCustomer: boolean;
}

export default Vue.extend({
  name: "TarikUnit",
  data() {
    this.getWoNumber = debounceProcess(this.getWoNumber, 200);
    this.getInternalContractNumber = debounceProcess(
      this.getInternalContractNumber,
      200
    );
    this.getCustomerName = debounceProcess(this.getCustomerName, 200);
    return {
      form: this.$form.createForm(this, { name: "tarikUnit" }),
      page: this.page || (1 as number),
      limit: this.limit || (10 as number),
      params: {} as RequestQueryParamsModel,
      customerId: "" as string,
      DEFAULT_DATE_FORMAT,
      totalData: 0 as number,
      loading: {
        loadingFind: false,
        loadingInternalContractNumber: false,
        download: false,
        print: false,
        loadingStatus: false,
        loadingCustomer: false,
      } as LoadingComponent,
      columnsTable: [
        {
          title: "No",
          dataIndex: "no",
          key: "no",
          width: 150,
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Internal Contract Number",
          dataIndex: "icNumber",
          key: "icNumber",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_customer_name"),
          dataIndex: "customerName",
          key: "customerName",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: "Rent Period",
          dataIndex: "rentPeriod",
          key: "rentPeriod",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: "Qty",
          dataIndex: "qty",
          key: "qty",
          width: 150,
          scopedSlots: { customRender: "isQty" },
        },
        {
          title: this.$root.$t("lbl_bapu_number"),
          dataIndex: "withdrawalNumber",
          key: "withdrawalNumber",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$root.$t("lbl_unit_code"),
          dataIndex: "unitCode",
          key: "unitCode",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$root.$t("lbl_withdrawal_date"),
          dataIndex: "withdrawalDate",
          key: "withdrawalDate",
          width: 150,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$root.$t("lbl_action").toString(),
          dataIndex: "operation",
          key: "operation",
          scopedSlots: { customRender: "operation" },
          button: ["view"],
          width: 120,
          align: "center",
        },
      ],
      formRules: {
        internalContractNumber: {
          label: "Internal Contract Number",
          name: "internalContractNumber",
          placeholder: "Select Internal Contract Number",
          decorator: [
            "internalContractNumber",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        customerName: {
          label: "lbl_customer_name",
          name: "customerName",
          placeholder: "lbl_customer_name_placeholder",
          decorator: [
            "customerName",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        withdrawalNumber: {
          label: "lbl_bapu_number",
          name: "withdrawalNumber",
          placeholder: "lbl_bapu_number_placeholder",
          decorator: [
            "withdrawalNumber",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        unitCode: {
          label: "lbl_unit_code",
          name: "unitCode",
          placeholder: "lbl_unit_code_placeholder",
          decorator: [
            "unitCode",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
        withdrawalDate: {
          label: "lbl_withdrawal_date",
          name: "withdrawalDate",
          decorator: [
            "withdrawalDate",
            {
              rules: [
                {
                  required: false,
                  message: this.$t(Messages.VALIDATION_REQUIRED_ERROR),
                },
              ],
            },
          ],
        },
      },
      dataSource: [] as DataResponseBastWithdrawl[],
      dataInternalContractNumber: [] as DataResponseBastWithdrawl[],
      dataCustomerName: [] as Option<ListContactDataDto>[],
      woNumber: "" as string,
    };
  },
  methods: {
    responseViewTable(response) {
      this.$router.push(`/sales/tarik-unit/detail/${response.data.id}`);
    },
    buildIcNumberSearch(valueSearch: string): string {
      const builder = new SearchBuilder();
      const conditions: string[] = [];
      if (valueSearch)
        conditions.push(
          builder
            .push([SEARCH_FIELD.DOCUMENT_NO, valueSearch], { like: "both" })
            .build()
        );
      if (this.customerId)
        conditions.push(
          builder.push([SEARCH_FIELD.CUSTOMER_ID, this.customerId]).build()
        );
      return conditions.join(SearchBuilder.AND);
    },
    getInternalContractNumber(valueSearch) {
      const params: RequestQueryParamsModel = {
        limit: 10,
        page: 0,
      };
      params.search = this.buildIcNumberSearch(valueSearch);
      this.loading.loadingInternalContractNumber = true;
      salesOrderServices
        .getListBastWithdrawl(params)
        .then(response => {
          this.dataInternalContractNumber = response.data
            .map((dataMap, index) => {
              return { ...dataMap, key: index, no: index + 1 };
            })
            .filter(
              (data, index, self) =>
                index === self.findIndex(t => t.icNumber === data.icNumber)
            );
        })
        .finally(() => (this.loading.loadingInternalContractNumber = false));
    },
    handleChangeCustomer(value) {
      this.form.resetFields([FORM_FIELD.INTERNAL_CONTRACT_NUMBER]);
      this.customerId = value;
      this.getInternalContractNumber("");
    },
    getCustomerName(valueSearch: string) {
      const { findCustomers, filterBy, toOptionsCustomer } = useContactData();
      const params = new RequestQueryParams();
      if (valueSearch) {
        params.search = filterBy({
          firstName: valueSearch,
          lastName: valueSearch,
        });
      }
      this.loading.loadingCustomer = true;
      findCustomers(params)
        .then(response => {
          this.dataCustomerName = toOptionsCustomer(response.data);
        })
        .finally(() => (this.loading.loadingCustomer = false));
    },
    responsePageSizeChange(response: ResponsePagination): void {
      this.limit = response.size;
      this.page = 1;
      this.onSubmit(false);
    },
    responseCurrentPageChange(response: ResponsePagination): void {
      this.page = response.page;
      this.onSubmit(false);
    },
    checkValue(value): string {
      if (value && !value.includes("undefined")) {
        return value;
      } else {
        return ",ALL";
      }
    },
    checkParams(res): string {
      let params = "";
      // company is mandatory
      params += this.$store.state.authStore.authData.companyName;
      params += this.checkValue(`,${res["customerMaintenanceNumber"]}`);
      params += this.checkValue(`,${res["workOrderNumber"]}`);
      params += this.checkValue(`,${res["csfNumber"]}`);
      params += this.checkValue(`,${res["customerName"]}`);
      params += this.checkValue(`,${res["unitCode"]}`);
      params += this.checkValue(
        res["dateFrom"]
          ? `,${moment(res["dateFrom"]).format("DD-MMM-yyyy")}`
          : null
      );
      params += this.checkValue(
        res["dateTo"] ? `,${moment(res["dateTo"]).format("DD-MMM-yyyy")}` : null
      );

      return params;
    },
    assignSearch(key: string, value: string | Moment[]): string {
      const builder = new SearchBuilder();
      if (!Array.isArray(value)) {
        if (key === FORM_FIELD.CUSTOMER_NAME && value)
          return builder.push([SEARCH_FIELD.CUSTOMER_ID, value]).build();
        else if (key === FORM_FIELD.INTERNAL_CONTRACT_NUMBER && value)
          return builder.push([SEARCH_FIELD.DOCUMENT_NO, value]).build();
        else if (key === FORM_FIELD.WITHDRAWAL_NUMBER && value)
          return builder
            .push([SEARCH_FIELD.WITHDRAWAL_NUMBER, value], { like: "both" })
            .build();
        else if (key === FORM_FIELD.UNIT_CODE && value)
          return builder
            .push([SEARCH_FIELD.UNIT_CODE, value], { like: "both" })
            .build();
        else return "";
      }
      if (key === FORM_FIELD.WITHDRAWAL_DATE && value.length === 2)
        return builder
          .push(
            [
              SEARCH_FIELD.WITHDRAWAL_DATE,
              moment(value[0])
                .set({ hour: 0, minute: 0, second: 0 })
                .utc()
                .format(),
            ],
            { het: true }
          )
          .and()
          .push(
            [
              SEARCH_FIELD.WITHDRAWAL_DATE,
              moment(value[1])
                .set({ hour: 23, minute: 59, second: 59 })
                .utc()
                .format(),
            ],
            { let: true }
          )
          .build();
      else return "";
    },
    dynamicSearch(res, baseSearch = ""): string {
      const conditions = Object.keys(res).map(key =>
        this.assignSearch(key, res[key])
      );
      return [baseSearch, ...conditions]
        .filter(condition => !!condition)
        .join(SearchBuilder.AND);
    },
    onSubmit(firstSearch): void {
      this.form.validateFields((err, values) => {
        if (err) return;
        const params: RequestQueryParamsModel = {
          page: this.page - 1,
          limit: this.limit,
        };
        if (firstSearch) {
          params.page = 0;
          this.page = 1;
        }
        params.search = this.dynamicSearch(values);
        this.loading.loadingFind = true;
        salesOrderServices
          .getListBastWithdrawl(params)
          .then(response => {
            this.totalData = response.totalElements;
            this.dataSource = response.data.map((dataMap, index) => {
              return {
                ...dataMap,
                key: index,
                no:
                  response.currentPage === 0
                    ? index + 1
                    : this.limit * (this.page - 1) + index + 1,
              };
            });
          })
          .finally(() => (this.loading.loadingFind = false));
      });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].componentOptions.children[1].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
  },
  created() {
    this.getCustomerName("");
    this.getInternalContractNumber("");
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      };
    },
  },
});
